'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("guPresConnexion", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./guPresConnexion.html")
  };
});
ngModule.directive("guPresOrganisationGenerale", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      module: "@module"
    },
    template: require("./guPresOrganisationGenerale.html")
  };
});
ngModule.directive("guPresFonctionnalitesTransverses", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./guPresFonctionnalitesTransverses.html")
  };
});
ngModule.directive("guPresAccueilRelation", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./guPresAccueilRelation.html")
  };
});
ngModule.directive("guPresConventions", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./guPresConventions.html")
  };
});
ngModule.directive("guPresVocabulaire", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./guPresVocabulaire.html")
  };
});
ngModule.directive("guPresGestionCompte", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./guPresGestionCompte.html")
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/guide-utilisateur/gu-pres-components.js
// module id = 2783
// module chunks = 13